import axios from "axios";
import {SmallPopover} from "../../components/popover/SmallPopover";

export class add2Basket {
  constructor(buttonEl, counterEl) {
    this.buttonEl = buttonEl;
    this.counterEl = counterEl;
  }
  init() {
    if (!this.buttonEl) return;
    this.getData();
    console.log('inited');
  }
  actions(response) {
    this.basketSmallEl = document.querySelector('.js-basket-small');
    this.respPopover = new SmallPopover(this.buttonEl);
    if (!this.respPopover.inited) {
      this.respPopover.init();
    }
    if(response.data['STATUS'] === 'SUCCESS') {
      document.dispatchEvent(new CustomEvent('product-added', { 'detail': {popoverEl: this.respPopover.dropEl} }));
      this.respPopover.setText(`<svg width="20" height="20"><use xlink:href="#plus-circle"></use></svg> ${response.data['MESSAGE']}`);
    } else {
      this.respPopover.setText(response.data['MESSAGE']);
    }
    this.respPopover.toggle();
    this.basketSmallEl.innerHTML = response.data['SMALL_BASKET'];
  }
  getData() {
    axios.get('/local/ajax/add2basket.php', {
      params: {
        id: this.buttonEl.dataset.id,
        quantity: this.counterEl ? this.counterEl.value : 1
      }
    })
      .then(response => {
        console.log(response);
        this.actions(response);
      })
      .catch(error => alert(error));
  }
}
